export const PUBLIC_SITE_URL =
  process.env.REACT_APP_PUBLIC_SITE_URL || "https://flowguard.deals";

export const publicSitePath = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${PUBLIC_SITE_URL}${normalizedPath}`;
};

const AUTH_HINT_COOKIE = "flowguard_auth_hint";

const getCookieDomain = () => {
  if (typeof window === "undefined") return "";
  return window.location.hostname.endsWith("flowguard.deals")
    ? "; domain=.flowguard.deals"
    : "";
};

const getSecureCookieFlag = () => {
  if (typeof window === "undefined") return "";
  return window.location.protocol === "https:" ? "; Secure" : "";
};

export const setPublicSiteAuthHint = () => {
  if (typeof document === "undefined") return;
  document.cookie = `${AUTH_HINT_COOKIE}=1; path=/; max-age=2592000; SameSite=Lax${getSecureCookieFlag()}${getCookieDomain()}`;
};

export const clearPublicSiteAuthHint = () => {
  if (typeof document === "undefined") return;
  document.cookie = `${AUTH_HINT_COOKIE}=; path=/; max-age=0; SameSite=Lax${getSecureCookieFlag()}${getCookieDomain()}`;
};
